"use client";

import { ThreeDMarquee } from "@/components/common/3d-marquee/3d-marquee";
import {
  ImgMarqueeMobileAppServices1,
  ImgMarqueeMobileAppServices10,
  ImgMarqueeMobileAppServices11,
  ImgMarqueeMobileAppServices12,
  ImgMarqueeMobileAppServices2,
  ImgMarqueeMobileAppServices3,
  ImgMarqueeMobileAppServices4,
  ImgMarqueeMobileAppServices5,
  ImgMarqueeMobileAppServices6,
  ImgMarqueeMobileAppServices7,
  ImgMarqueeMobileAppServices8,
  ImgMarqueeMobileAppServices9,
} from "@/lib/images";
import { useEffect, useState } from "react";

function shuffleArray<T>(array: T[]): T[] {
  return [...array].sort(() => Math.random() - 0.5);
}

const staticImages1 = [
    ImgMarqueeMobileAppServices1,
    ImgMarqueeMobileAppServices2,
    ImgMarqueeMobileAppServices3,
    ImgMarqueeMobileAppServices4,
    ImgMarqueeMobileAppServices9,
];

const staticImages2 = [
    ImgMarqueeMobileAppServices4,
    ImgMarqueeMobileAppServices5,
    ImgMarqueeMobileAppServices6,
    ImgMarqueeMobileAppServices7,
    ImgMarqueeMobileAppServices11,
];

const staticImages3 = [
    ImgMarqueeMobileAppServices8,
    ImgMarqueeMobileAppServices9,
    ImgMarqueeMobileAppServices10,
    ImgMarqueeMobileAppServices1,
    ImgMarqueeMobileAppServices12,
];

const staticImages4 = [
    ImgMarqueeMobileAppServices4,
    ImgMarqueeMobileAppServices5,
    ImgMarqueeMobileAppServices6,
    ImgMarqueeMobileAppServices7,
    ImgMarqueeMobileAppServices1,
];

function SideMarqueeSectionMobileAppThat() {
  const [shuffledColumns, setShuffledColumns] = useState([
    staticImages1,
    staticImages2,
    staticImages3,
    staticImages4,
  ]);

  useEffect(() => {
    const column1 = shuffleArray(staticImages1);
    const column2 = shuffleArray(staticImages2);
    const column3 = shuffleArray(staticImages3);
    const column4 = shuffleArray(staticImages4);
    setShuffledColumns(shuffleArray([column1, column2, column3, column4]));
  }, []);

  // Custom transition durations for faster scrolling
  const customTransitions = {
    evenColumnDuration: 6, // Faster speed (was 10)
    oddColumnDuration: 9,  // Faster speed (was 15)
  };

  return (
    <div className="lg:flex hidden">
      {/* <ThreeDMarquee className="" columns={[column1, column2, column3,column4]} /> */}
      <ThreeDMarquee
        columns={shuffledColumns}
        wrapperClassName="w-[1450px] scale-[0.45] sm:scale-[0.65] lg:scale-[1.05] 2xl:scale-[1]"
        gridClassName="grid origin-top-center grid-cols-8 xl:grid-cols-6 gap-6 transform"
        gridStyle={{ transform: "rotateX(0deg) rotateY(0deg) rotateZ(8deg)" }}
        imageClassName="border-none"
        transitionDurations={customTransitions}
      />
    </div>
  );
}

export default SideMarqueeSectionMobileAppThat;
